import { useMutation } from '@tanstack/react-query'
import { BillingApiClient } from '~/features/billing/services'
import { showErrorToast, showSuccessToast } from '@bpinternal/ui-kit-next'
import { getQueryKey } from '~/services'
import { queryClient } from '../../../providers/ReactQuery'
import { AutoRechargeSettings } from '../types'

export function useSetAutoRechargeSettings({ workspaceId }: { workspaceId: string }) {
  return useMutation({
    gcTime: 0,
    mutationFn: async ({ settings }: { settings: Partial<AutoRechargeSettings> }) => {
      return BillingApiClient.updateAutoRechargeSettings(workspaceId, settings)
    },
    onSuccess: () => {
      showSuccessToast('Auto recharge settings updated successfully')
      void queryClient.refetchQueries({
        queryKey: getQueryKey('workspaces_/$workspaceId_/billing/autoRecharge', { workspaceId }),
      })
    },
    onError: () => {
      showErrorToast('There was an error while updating your auto recharge settings. Please try again.')
    },
    meta: {
      suppressError: true,
    },
  })
}
